import * as types from "./types";

import {
    deleteSegment,
    postSegment,
    getSegment,
    getSegments,
    updateSegment,
    getCustomersBySegment,
} from "./services";

export async function getSegmentsAction({commit}) {
    commit(types.LOADING_SEGMENT, true);
    try {
        const {data} = await getSegments();
        commit(types.GET_SEGMENTS, data.result);
    }
    catch(e) {
        throw e;
    }
    commit(types.LOADING_SEGMENT, false);
}

export async function removeSegmentAction({commit}, payload) {
    commit(types.LOADING_SEGMENT, true);
    try {
        await deleteSegment(payload);
        commit(types.REMOVE_SEGMENT, payload);
    }
    catch(e) {
        throw e;
    }
    finally{
        commit(types.LOADING_SEGMENT, false);
    }
  
}

export async function addSegmentAction({commit}, payload) {
    commit(types.LOADING_SEGMENT, true);
    try {
        await postSegment(payload);        
        commit(types.ADD_SEGMENT, payload);
    }
    catch(e) {
        throw e;
    }
    finally{
        commit(types.LOADING_SEGMENT, false);
    }
  
}


export async function getSegmentByIDAction({commit}, payload) {
    commit(types.LOADING_SEGMENT, true);
    try {

        const {data} = await getSegment(payload);
        commit(types.GET_SEGMENT, data.result);
    }
    catch(e) {
        throw e;
    }
    commit(types.LOADING_SEGMENT, false);
}


export async function updateSegmentAction({commit}, payload) {
    commit(types.LOADING_SEGMENT, true);
    try {
        await updateSegment(payload);
        commit(types.UPDATE_SEGMENT, payload);
    }
    catch(e) {
        throw e;
    }
    commit(types.LOADING_SEGMENT, false);
}



export async function getCustomersBySegmentAction({commit}, payload) {
    commit(types.LOADING_SEGMENT, true);
    try {
        const {data} = await getCustomersBySegment(payload);
        commit(types.GET_CUSTOMERS_BY_SEGMENT, data.result);
    }
    catch(e) {
        throw e;
    }
    commit(types.LOADING_SEGMENT, false);
}